import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from 'src/app/features-common/constants/ZipCodes';
import { RetailerService } from '../../retailers/retailer.service';
import { ManageUserService } from '../manage-user.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent extends FeaturesBaseComponent implements OnInit {
  newUserForm: FormGroup;
  phone: (string | RegExp)[];
  usStateZips = ZipCodes.USAStatesShort;
  thresholdAmount = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250];
  roles: string[] = ['Sales Rep', 'Admin', 'User', 'Retailer']
  //roles: string[] = ['Admin', 'Sub-Admin', 'Retailer', 'Sales Rep/Distr', 'Billing Dept', 'Customer support'];
  retailers: string[] = ['Henry', 'Peter', 'Lee', 'Alca', 'Kim']
  pricelists: any = [];
  businessnames: any = [];
  autoReloadStatus: boolean = false;
  selectedRole: any;
  showSalesRepFields: boolean = false;
  emailPattern: RegExp;
  phonePattern: RegExp;
  showRetailerList: boolean = false;
  showIvrCode: boolean =  false;
  constructor(private router: Router,private retailerService: RetailerService, private dialog: MatDialog, private manageuserService: ManageUserService) {
    super();
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    this.emailPattern = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
    this.phonePattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    this.retailerService.getsalesPricelists().subscribe(
      res => {
        if (res['httpcode'] == 200 && res['data'] != null) {
          this.pricelists = res['data']
        }
      }
    );

    this.retailerService.getBusinessnames().subscribe(
      res => {
        if (res['httpcode'] == 200 && res['data'] != null) {
          this.businessnames = res['data']
        }
      }
    );

    this.retailerService.getRoles().subscribe(
      res => {
        if (res['httpcode'] == 200 && res['data'] != null) {
          this.roles = res['data']
        }
      }
    );    

  }
  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }


  ngOnInit(): void {
    super.ngOnInit()
    this.initForm()
  }

  onIvrStatusChange(e) {
    if (e == 'Yes') {
      this.newUserForm.controls['ivrAccess'].setValidators([Validators.required]);
      this.newUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = true;
    }
    else if (e == 'No') {
      this.newUserForm.controls['ivrCode'].clearValidators()
      this.newUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = false;

    }
  }


  initForm() {
    this.newUserForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      userName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      mobileNumber: new FormControl('', [Validators.required, Validators.pattern(this.phonePattern)]),
      role: new FormControl('', [Validators.required]),
      retailerId: new FormControl(''),
      creditLineAmnt: new FormControl(''),
      thresholdAmnt: new FormControl('',),
      autoReloadStatus: new FormControl(true),
      pricelist: new FormControl(''),
      address1: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]),
      ivrAccess: new FormControl('No', [Validators.required]),
      //ivrNumber: new FormControl(''),
      ivrCode: new FormControl(''),
    })
  }

  get f() {
    return this.newUserForm.controls;
  }

  addUserSubmit($event) {
    
    if (!this.newUserForm.valid) {
      return
    }

    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
        buttonText: {
          ok: 'pages.placeholders.Save',
          cancel: 'pages.placeholders.cancel'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.setSubmitParameters(this.addUserSubmit)
      }
    });
  }
  setSubmitParameters(addUserSubmit: ($event: any) => void) {
    let formData:any = {

      "address1": this.newUserForm.get('address1').value,
      "city": this.newUserForm.get('city').value,
      "creditLineAmount": this.newUserForm.get('creditLineAmnt').value,
      "firstName": this.newUserForm.get('firstName').value,
      "lastName": this.newUserForm.get('lastName').value,
      "email": this.newUserForm.get('email').value,
      "mobileNumber": this.newUserForm.get('mobileNumber').value,
      "priceList": this.newUserForm.get('pricelist').value,
      "role": this.newUserForm.get('role').value,
      "retailerId": this.newUserForm.get('retailerId').value,
      "setThresholdAmount": this.newUserForm.get('thresholdAmnt').value,
      "setToAutoReload": this.newUserForm.get('autoReloadStatus').value.toString(),
      "state": this.newUserForm.get('state').value,
      "userName": this.newUserForm.get('userName').value,
      "zipCode": this.newUserForm.get('zip').value,
      
      "ivrAccess": this.newUserForm.get('ivrAccess').value,
      //"ivrNumber": this.newUserForm.get('ivrNumber').value,
      "ivrCode": this.newUserForm.get('ivrCode').value,


    }
    // if (this.selectedRole == 'Retailer') {
    //   formData['retailerId'] = this.newUserForm.get('retailerId').value;
    // }
   
    this.manageuserService.addNewUser(formData).subscribe(
      res => {
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
          this.toastrService.success('User created successfully!', 'Success')
          this.initForm();
          this.router.navigateByUrl('features/manage-users/all-users')
        }
      }
    )
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.placeholders.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //this.addRetailerForm.reset()
        this.router.navigate(['features/retailers/allretailers'])
      }
    });
    

  }
  checkautoReloadStatus(e) {
    this.autoReloadStatus = e.checked;
    if (this.autoReloadStatus) {
      this.newUserForm.controls['thresholdAmnt'].setValidators([Validators.required])
    }
    else {
      this.newUserForm.controls['thresholdAmnt'].clearValidators();
    }
    this.newUserForm.controls['thresholdAmnt'].updateValueAndValidity();
  }
  onRoleSelected(e: MatSelectChange) {
     this.selectedRole = e.value;
    if (this.selectedRole == 'Sales Rep') {
      this.showSalesRepFields = true;
      this.showRetailerList = false;
      this.newUserForm.controls['creditLineAmnt'].setValidators([Validators.required])
      this.newUserForm.controls['thresholdAmnt'].setValidators([Validators.required])
      this.newUserForm.controls['autoReloadStatus'].setValue(true)
      this.newUserForm.controls['autoReloadStatus'].setValidators([Validators.required])
      this.newUserForm.controls['pricelist'].setValidators([Validators.required])
      this.newUserForm.controls['pricelist'].updateValueAndValidity();
      this.newUserForm.controls['autoReloadStatus'].updateValueAndValidity();
      this.newUserForm.controls['thresholdAmnt'].updateValueAndValidity();
      this.newUserForm.controls['creditLineAmnt'].updateValueAndValidity();
      this.newUserForm.controls['retailerId'].clearValidators()
      this.newUserForm.controls['retailerId'].updateValueAndValidity();
      this.newUserForm.controls['ivrAccess'].clearValidators()
      this.newUserForm.controls['ivrAccess'].updateValueAndValidity();
      this.newUserForm.controls['ivrCode'].clearValidators()
      this.newUserForm.controls['ivrCode'].updateValueAndValidity();
      return
  }
  if (this.selectedRole == 'Retailer') {
    this.showSalesRepFields = false;
    this.showRetailerList = true;
    this.newUserForm.controls['retailerId'].setValidators([Validators.required]);
    this.newUserForm.controls['retailerId'].updateValueAndValidity()
    if (this.newUserForm.get('ivrAccess').value == 'Yes'){
      this.newUserForm.controls['ivrAccess'].setValidators([Validators.required]);
      this.newUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = true;
    }
    else{
      this.newUserForm.controls['ivrCode'].clearValidators()
      this.newUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = false;

    }

    
    this.newUserForm.controls['creditLineAmnt'].clearValidators()
    this.newUserForm.controls['thresholdAmnt'].clearValidators()
    this.newUserForm.controls['autoReloadStatus'].setValue(false)
    this.newUserForm.controls['autoReloadStatus'].clearValidators()
    this.newUserForm.controls['pricelist'].clearValidators()
    
    this.newUserForm.controls['autoReloadStatus'].updateValueAndValidity();
    this.newUserForm.controls['thresholdAmnt'].updateValueAndValidity();
    this.newUserForm.controls['creditLineAmnt'].updateValueAndValidity();
    this.newUserForm.controls['pricelist'].updateValueAndValidity();
    return
  }
  this.showSalesRepFields = false;
  this.showRetailerList = false;
    this.newUserForm.controls['creditLineAmnt'].clearValidators()
    this.newUserForm.controls['thresholdAmnt'].clearValidators()
    this.newUserForm.controls['autoReloadStatus'].setValue(false)
    this.newUserForm.controls['autoReloadStatus'].clearValidators()
    this.newUserForm.controls['pricelist'].clearValidators()
    this.newUserForm.controls['pricelist'].updateValueAndValidity();
    this.newUserForm.controls['autoReloadStatus'].updateValueAndValidity();
    this.newUserForm.controls['thresholdAmnt'].updateValueAndValidity();
    this.newUserForm.controls['creditLineAmnt'].updateValueAndValidity();
    this.newUserForm.controls['retailerId'].clearValidators()
    this.newUserForm.controls['retailerId'].updateValueAndValidity();

    this.newUserForm.controls['ivrAccess'].clearValidators()
    this.newUserForm.controls['ivrAccess'].updateValueAndValidity();
    this.newUserForm.controls['ivrCode'].clearValidators()
    this.newUserForm.controls['ivrCode'].updateValueAndValidity();
    return
  }
  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
